const actions = {
  async hideArea(context,data){
    console.log('soft delete area',data)
  },
}

export default {
  actions
};
